
// 资金划转接口
export default {
  // 查询代为转让站内信信息
  param_transferMsgInfo: {
    url: '/intraday-trade-query-mongo/mongoQuery/transferMsgInfo',
    param: {
      sort: [
        {
          direction: 'DESC',
          property: 'inMsgId'
        }
      ]
    }
  },
  // 修改站内信息为已读
  param_updateInMsgReadFlag: {
    url: '/intraday-margin-manage/msgTemplateController/updateInMsgReadFlag',
    // url: '/intraday-marketing-system/msgTemplateController/updateInMsgReadFlag',
    param: {}
  },
  // 资金列表查询
  param_mineAsset: {
    url: '/intraday-trade-query-mongo/mongoQuery/mineAssetList',
    param: {}
  },
  // 资金划转(多市场间划转)
  param_transferFundsOwn: {
    url: '/intraday-margin-manage/operate/transferFundsOwn',
    // url: '/intraday-marketing-system/operate/transferFundsOwn',
    param: {
      amount: null,
      pwd: null,
      fromMarketId: null,
      toMarketId: null
    }
  },

  // firmId查询(已开通市场查询)
  param_firmIdSearch: {
    url: '/authn/authn/getFirmListByUserId',
    param: {}
  }
}
